import styled from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
  background-color: ${({ theme, isLocal }) =>
    isLocal ? theme.light : theme.dark4};
  z-index: 1;
  position: relative;

  & > div:last-child {
    background-color: ${({ theme, isLocal }) =>
      isLocal ? theme.whiteWithMidOpacity : theme.dark4MidOpacity};
    z-index: 1;
  }
`;

export const ShieldBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(${({ bgImage }) => bgImage});
  background-repeat: no-repeat;
  background-size: 223px;
  background-position: calc(100% + 66px) center;
  filter: grayscale(100%);
  z-index: 0;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
  }
`;

export const TeamLabel = styled.div`
  position: relative;
  width: 94px;
  background-color: ${({ theme, isLocal }) =>
    isLocal ? theme.mainGreyOpacity : theme.dark5};
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }
`;

export const TeamLabelText = styled.div`
  position: relative;
  display: flex;
  width: auto;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  white-space: nowrap;
  transform-origin: 50% 50%;
  transform: translate(-50%, -50%) rotateZ(-90deg);
  font-size: 29px;
  color: ${({ theme, isLocal }) => (isLocal ? theme.black : theme.white)};
  span {
    order: ${({ isLocal }) => (isLocal ? 1 : 2)};
  }
  img {
    order: ${({ isLocal }) => (isLocal ? 2 : 1)};
    margin: 0 10px;
  }
`;

export const TableContainer = styled.div`
  padding: 39px;
  min-height: 500px;

  table {
    thead {
      th > div {
        text-transform: uppercase;
        text-align: center;
        color: ${({ theme, isLocal }) => (isLocal ? theme.black : theme.white)};
      }
    }
    thead tr,
    tbody tr {
      text-align: center;
      & td,
      & th {
        font-family: ${({ theme }) => theme.primaryFontBold};
        &:nth-child(2n) {
          font-family: ${({ theme }) => theme.primaryFontLight};
        }
      }
    }
    th,
    td {
      padding: 11px 6px;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 100%;
    padding: 0px;
    padding-top: 10px;
    table {
      thead {
        th > div {
          text-transform: uppercase;
          justify-content: center;
          color: ${({ theme }) => theme.black};
        }
      }
    }
  }
`;
